import { Pipe, PipeTransform } from '@angular/core';
import { LocaleCode } from 'src/app/Core/locale/locale.constants';
import { LanguageNavigationService } from 'src/app/Core/locale/language-navigation.service';

@Pipe({
  name: 'localeLink',
  standalone: true,
  pure: false,
})
export class LocaleLinkPipe implements PipeTransform {
  constructor(private languageNavigationService: LanguageNavigationService) {}

  transform(
    value: string | unknown[] | null | undefined,
    locale?: LocaleCode
  ): string | unknown[] | null | undefined {
    if (value === null || value === undefined) {
      return value;
    }

    if (typeof value === 'string') {
      if (!value.startsWith('/')) {
        return value;
      }
      return this.languageNavigationService.toLocalizedUrl(value, locale);
    }

    if (Array.isArray(value) && value.length > 0) {
      const [first, ...rest] = value;
      if (typeof first === 'string' && first.startsWith('/')) {
        return [
          this.languageNavigationService.toLocalizedUrl(first, locale),
          ...rest,
        ];
      }
    }

    return value;
  }
}
